module.exports = __webpack_public_path__ + "24138b29c302d1a01cfd2b29415b8d9a.svg";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/assets/double-arrow.svg
// module id = 1681
// module chunks = 2